import React from 'react';
import styles from './styles.scss';
import Overview from '../shared/Overview';
import {
  cartDataProps,
  isTrialProps,
  trialInfoProps
} from '../../shared/prop-types';
import Card from '../shared/Card';
import Inset from '../shared/Inset';
import Pricing from '../shared/Pricing';
import Footnote from '../shared/Footnote';

const SummaryStudents = ({ cartData, isTrial, trialInfo }) => {
  return (
    <div className={styles.checkoutSummary}>
      <Card>
        <Inset>
          <Overview
            cartData={cartData}
            isTrial={isTrial}
            trialInfo={trialInfo}
          />
        </Inset>
        <Inset transparent={isTrial}>
          <Pricing
            isPrimary={true}
            label="Billed Today" // TODO: [fumba] copy
            cartData={cartData}
            showFootnote={!isTrial}
          />
        </Inset>
        {isTrial && (
          <Inset>
            <Pricing
              isPrimary={false}
              label="Billed After Trial" // TODO: [fumba] copy
              cartData={cartData}
              showFootnote={true}
            />
          </Inset>
        )}
        <Inset>
          <Footnote />
        </Inset>
      </Card>
    </div>
  );
};

SummaryStudents.propTypes = {
  cartData: cartDataProps.isRequired,
  trialInfo: trialInfoProps,
  isTrial: isTrialProps.isRequired
};

SummaryStudents.defaultProps = {
  trialInfo: null
};

export default SummaryStudents;
